<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
              <router-link to="/liste-parents" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
            </div>
            <table class="table">
              <tbody>
                
                <tr v-if="parent?.nom">
                  <td>Nom :</td>
                  <td>{{ parent?.nom }}</td>
                </tr>
                <tr v-if="parent?.prenom">
                  <td>Prénom :</td>
                  <td>{{ parent?.prenom }}</td>
                </tr>
                <tr v-if="parent?.adresse">
                  <td>Adresse parent :</td>
                  <td>{{ parent?.adresse }}</td>
                </tr>
                <tr  v-if="parent?.email">
                  <td>Email :</td>
                  <td>{{ parent?.email }}</td>
                </tr>
                <tr v-if="parent?.telephone1">
                  <td>Téléphone 1 :</td>
                  <td>{{ parent?.telephone1 }}</td>
                </tr>
                <tr v-if="parent?.telephone2">
                  <td>Téléphone 2 :</td>
                  <td>{{ parent?.telephone2 }}</td>
                </tr>
                
               <tr v-if="parent?.lienParente">
                  <td>Lien parenté :</td>
                  <td>{{ parent?.lienParente }}</td>
                </tr>
                <tr v-if="parent?.quartier">
                  <td>Quartier:</td>
                  <td>{{ parent?.quartier.libelle }}</td>
                </tr>
                <tr v-if="parent?.adresse">
                  <td>Adrese :</td>
                  <td>{{ parent?.adresse }}</td>
                </tr>     
                
              
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Parent } from "@/models/Parent";
import { error, format_Date, showModal } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewParent",
  setup: () => {
    const route = useRoute();
    const parent = ref<Parent | null>(null);

    function getParent(id: string) {
      return ApiService.get("/parents", id)
        .then(({ data }) => {
          parent.value = data.data; 
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    } 
    onMounted(() => {
      const id = route.params.id as string;
      getParent(id);
    });

    return { 
      parent,
      getParent,
      format_Date,
     };
  },
});
</script>
